export default __webpack_public_path__ + "static/media/sigma.b3ee976d.svg";